import React, { useEffect, useRef } from 'react';
import './ComingSoon.css';

const ComingSoon = () => {
  const canvasRef = useRef(null);
  const particlesRef = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationId;

    // Set canvas size
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Particle class
    class Particle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.vx = (Math.random() - 0.5) * 0.5;
        this.vy = (Math.random() - 0.5) * 0.5;
        this.size = Math.random() * 2 + 1;
        this.opacity = Math.random() * 0.5 + 0.2;
        this.connectionDistance = 150;
      }

      update() {
        this.x += this.vx;
        this.y += this.vy;

        if (this.x < 0 || this.x > canvas.width) this.vx *= -1;
        if (this.y < 0 || this.y > canvas.height) this.vy *= -1;
      }

      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(73, 193, 244, ${this.opacity})`;
        ctx.fill();
      }

      connect(particles) {
        particles.forEach(particle => {
          const dx = this.x - particle.x;
          const dy = this.y - particle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < this.connectionDistance) {
            ctx.beginPath();
            ctx.strokeStyle = `rgba(73, 193, 244, ${0.1 * (1 - distance / this.connectionDistance)})`;
            ctx.lineWidth = 1;
            ctx.moveTo(this.x, this.y);
            ctx.lineTo(particle.x, particle.y);
            ctx.stroke();
          }
        });
      }
    }

    // Initialize particles
    const particles = [];
    for (let i = 0; i < 50; i++) {
      particles.push(new Particle());
    }
    particlesRef.current = particles;

    // Animation loop
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach(particle => {
        particle.update();
        particle.draw();
        particle.connect(particles);
      });

      animationId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <div className="coming-soon-container">
      {/* Background Canvas */}
      <canvas
        ref={canvasRef}
        className="background-canvas"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: -1,
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)'
        }}
      />

      {/* Main Content */}
      <div className="coming-soon-content">
        {/* AI Brain Animation */}
        <div className="ai-brain-container">
          <div className="ai-brain">
            <div className="brain-node node-1"></div>
            <div className="brain-node node-2"></div>
            <div className="brain-node node-3"></div>
            <div className="brain-node node-4"></div>
            <div className="brain-node node-5"></div>
            <div className="brain-node node-6"></div>
            <div className="brain-node node-7"></div>
            <div className="brain-node node-8"></div>
            <div className="brain-node node-9"></div>
            <div className="brain-node node-10"></div>
            <div className="brain-node node-11"></div>
            <div className="brain-node node-12"></div>
            
            {/* Connection Lines */}
            <svg className="brain-connections" viewBox="0 0 200 200">
              <path className="connection-line" d="M50,50 Q100,30 150,50" />
              <path className="connection-line" d="M50,50 Q100,70 150,50" />
              <path className="connection-line" d="M50,150 Q100,130 150,150" />
              <path className="connection-line" d="M50,150 Q100,170 150,150" />
              <path className="connection-line" d="M50,50 Q100,100 50,150" />
              <path className="connection-line" d="M150,50 Q100,100 150,150" />
              <path className="connection-line" d="M50,50 Q100,100 150,150" />
              <path className="connection-line" d="M150,50 Q100,100 50,150" />
            </svg>
          </div>
        </div>

        {/* Text Content */}
        <div className="text-content">
          <h1 className="coming-soon-title">
            <span className="title-word title-word-1">Coming</span>
            <span className="title-word title-word-2">Soon</span>
          </h1>
          
          <p className="coming-soon-subtitle">
            We're working on something amazing
          </p>
          
          <div className="ai-features">
            <div className="feature-item">
              <div className="feature-icon">
                <div className="pulse-dot"></div>
              </div>
              <span>AI-Powered Analysis</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <div className="pulse-dot"></div>
              </div>
              <span>Advanced Data Processing</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <div className="pulse-dot"></div>
              </div>
              <span>Real-time Insights</span>
            </div>
          </div>

          <div className="progress-indicator">
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
            <span className="progress-text">Development in Progress</span>
          </div>
        </div>

        {/* Floating Elements */}
        <div className="floating-elements">
          <div className="floating-element element-1">⚡</div>
          <div className="floating-element element-2">🔬</div>
          <div className="floating-element element-3">📊</div>
          <div className="floating-element element-4">🌊</div>
          <div className="floating-element element-5">🌍</div>
          <div className="floating-element element-6">🔍</div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;